const Sentiments = new Map();

Sentiments.set(-2, {
  value: '-2',
  text: '-2',
  color: '#FF5500',
});

Sentiments.set(-1, {
  value: '-1',
  text: '-1',
  color: '#FFBB99',
});

Sentiments.set(0, {
  value: '0',
  text: '0',
  color: '#E3E5E8',
});

Sentiments.set(1, {
  value: '1',
  text: '1',
  color: '#A3BEF5',
});

Sentiments.set(2, {
  value: '2',
  text: '2',
  color: '#1656E9',
});

Sentiments.set(99, {
  value: '99',
  text: '99',
  color: '#FFFFFF',
});

export default Sentiments;
